@if (cellConfig() && cellDisplayValue()) {
    @if (routerLink(); as link) {
        <a [routerLink]="link" class="copy-cell-link">{{ cellDisplayValue() }}</a>
    } @else {
        {{ cellDisplayValue() }}
    }
    <button pulse-button type="button" class="link btn-icon-only copy-btn" (click)="copyValue()">
        <fa-icon [icon]="faCopy" [fixedWidth]="true" />
        <span class="visually-hidden">{{
            cellConfig().copyButtonAccessibleLabel | translate
        }}</span>
    </button>
}
